module.exports = __webpack_public_path__ + "static/18-a1171d29632948efd50cdf7c18588970.png";